
export const getMenuHeader = () => {
  // 返回空数组，等待动态加载
  return [];
};

// 默认导出为空，会被动态替换
export const menuHeader = getMenuHeader();
export const menuAside = getMenuHeader();



/**
 * 应用商店角色菜单列表（预留变量）
 */
export const menuAppStore = []
/**
 * 分中心角色菜单列表（预留变量）
 */
export const menuCenterAppStore = []

/**
 * 用于应用商店角色登录后页面顶部的菜单（预留变量）
 */
export const headerMenuAppStore = []
/**
 * 用于分中心角色登录后页面顶部的菜单（预留变量）
 */
export const headerMenuCenterAppStore = []